// ── Chess Sound Effects ─────────────────────────────────────────────────
// Tiny synthesized tones via the Web Audio API — no external audio files
// to download (works fully offline), and respects a mute toggle.

const MUTE_KEY = 'iyanna_chess_muted';

let ctx = null;
function getCtx() {
  if (!ctx) {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return null;
    ctx = new AudioCtx();
  }
  return ctx;
}

export function isMuted() {
  try { return localStorage.getItem(MUTE_KEY) === '1'; }
  catch { return false; }
}

export function toggleMute() {
  const next = !isMuted();
  try { localStorage.setItem(MUTE_KEY, next ? '1' : '0'); } catch {}
  return next;
}

function tone(freq, startTime, duration, type = 'sine', gain = 0.09) {
  const audio = getCtx();
  if (!audio) return;
  const osc = audio.createOscillator();
  const g = audio.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(gain, startTime);
  g.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
  osc.connect(g);
  g.connect(audio.destination);
  osc.start(startTime);
  osc.stop(startTime + duration);
}

function play(fn) {
  if (isMuted()) return;
  const audio = getCtx();
  if (!audio) return;
  if (audio.state === 'suspended') audio.resume();
  try { fn(audio); } catch {}
}

export const sfx = {
  move: () => play(a => tone(440, a.currentTime, 0.09, 'triangle', 0.07)),
  capture: () => play(a => {
    tone(300, a.currentTime, 0.08, 'square', 0.06);
    tone(180, a.currentTime + 0.03, 0.09, 'square', 0.06);
  }),
  check: () => play(a => {
    tone(660, a.currentTime, 0.09, 'sawtooth', 0.06);
    tone(880, a.currentTime + 0.08, 0.12, 'sawtooth', 0.06);
  }),
  win: () => play(a => {
    [523, 659, 784, 1047].forEach((f, i) =>
      tone(f, a.currentTime + i * 0.11, 0.22, 'triangle', 0.08)
    );
  }),
  lose: () => play(a => {
    [392, 349, 293].forEach((f, i) =>
      tone(f, a.currentTime + i * 0.14, 0.25, 'sine', 0.07)
    );
  }),
  draw: () => play(a => {
    tone(440, a.currentTime, 0.15, 'sine', 0.07);
    tone(440, a.currentTime + 0.2, 0.15, 'sine', 0.07);
  }),
  notify: () => play(a => tone(700, a.currentTime, 0.07, 'sine', 0.05)),
};
